export const ActionTypes = {
  CREATE: 'CREATE',
  UPDATED: 'UPDATED',
  VIEW: 'VIEW',
  DELETE: 'DELETE',
  DESTROY_SESSION: 'DESTROY_SESSION'
};
